import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-package-detail',
  templateUrl: './service-package-detail.component.html',
  styleUrls: ['./service-package-detail.component.scss']
})
export class ServicePackageDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
